module.exports = __webpack_public_path__ + "img/cbd-isolate.e70faade.jpg";